export default __webpack_public_path__ + "static/media/basic-ed-gif.7d569e5d.gif";